import * as React from 'react';
import { createContext, useContext, useState, ReactNode } from 'react';

interface AppContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
  isNavMinimized: boolean;
  setIsNavMinimized: (minimized: boolean) => void;
  isScrolled: boolean;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [pageTitle, setPageTitle] = useState('');
  const [isNavMinimized, setIsNavMinimized] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(currentScroll > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AppContext.Provider value={{ pageTitle, setPageTitle, isNavMinimized, setIsNavMinimized, isScrolled }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
